import React from 'react';

const MethodologyDataSources = () => (
  <div className="space-y-6">
    <div className="flex items-center justify-between">
      <h2 className="text-2xl font-bold text-slate-800 dark:text-white">
        🔬 Methodology & Data Sources
      </h2>
      <span className="bg-purple-100 dark:bg-purple-900/40 text-purple-800 dark:text-purple-300 px-3 py-1 rounded-full text-sm font-medium">
        Premium Feature
      </span>
    </div>

    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
      <div className="bg-blue-50 dark:bg-blue-900/20 border border-blue-200 dark:border-blue-700 rounded-lg p-6">
        <h3 className="text-lg font-semibold text-blue-800 dark:text-blue-300 mb-4">
          📊 Data Sources
        </h3>
        <ul className="space-y-2 text-sm text-blue-700 dark:text-blue-400">
          <li>• DOE Industrial Assessment Centers database</li>
          <li>• ENERGY STAR benchmarking data</li>
          <li>• Rely Ability proprietary database (500+ facilities)</li>
          <li>• Industry-specific energy consumption patterns</li>
        </ul>
      </div>

      <div className="bg-green-50 dark:bg-green-900/20 border border-green-200 dark:border-green-700 rounded-lg p-6">
        <h3 className="text-lg font-semibold text-green-800 dark:text-green-300 mb-4">
          🔍 Analysis Method
        </h3>
        <ul className="space-y-2 text-sm text-green-700 dark:text-green-400">
          <li>• Statistical regression modeling</li>
          <li>• Peer facility benchmarking</li>
          <li>• Engineering calculations</li>
          <li>• Monte Carlo uncertainty analysis</li>
        </ul>
      </div>
    </div>

    <div className="bg-slate-50 dark:bg-slate-800 border border-slate-200 dark:border-slate-700 rounded-lg p-6">
      <h3 className="text-lg font-semibold text-slate-800 dark:text-white mb-4">
        🎯 Confidence Levels
      </h3>
      <div className="grid grid-cols-3 gap-4 text-center">
        <div className="bg-green-100 dark:bg-green-900/40 p-3 rounded border border-green-200 dark:border-green-700">
          <p className="font-bold text-green-800 dark:text-green-300">
            High (±10%)
          </p>
          <p className="text-sm text-green-600 dark:text-green-400">
            Proven technologies
          </p>
        </div>
        <div className="bg-yellow-100 dark:bg-yellow-900/40 p-3 rounded border border-yellow-200 dark:border-yellow-700">
          <p className="font-bold text-yellow-800 dark:text-yellow-300">
            Medium (±20%)
          </p>
          <p className="text-sm text-yellow-600 dark:text-yellow-400">
            Site-dependent measures
          </p>
        </div>
        <div className="bg-red-100 dark:bg-red-900/40 p-3 rounded border border-red-200 dark:border-red-700">
          <p className="font-bold text-red-800 dark:text-red-300">
            Low (±30%)
          </p>
          <p className="text-sm text-red-600 dark:text-red-400">
            Requires validation
          </p>
        </div>
      </div>
    </div>
  </div>
);

export default MethodologyDataSources;


